export const ROLE = {
  ROOT: 'root',
  TENANT_ADMIN: 'tenantAdmin',
  ADMIN: 'admin',
  PROCESS_ADMIN: 'processAdmin',
  TEAM_ADMIN: 'teamAdmin',
} as const
